export const REQUEST_EDITPROFILEDATA = 'REQUEST_EDITPROFILEDATA';
export const EDITPROFILEDATA_RECEIVED = 'EDITPROFILEDATA_RECEIVED';
export const CLEAR_EDITPROFILEDATA = 'CLEAR_EDITPROFILEDATA';

